import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {useLang} from "../context/LanguageContext";
import BackButton from "../components/BackButton";
import {useAuth} from "../context/AuthContext";
import {getVipData} from "../services/vipService";
import Footer from "../components/Footer";

const VipPage = () => {
    const navigate = useNavigate();
    const { t, language } = useLang()
    const { currentUser, hasVip } = useAuth();
    const [tickets, setTickets] = useState([]);
    const [errorRo, setErrorRo] = useState('');
    const [errorEn, setErrorEn] = useState('');
    const [errorEs, setErrorEs] = useState('');

    useEffect(() => {
        getVipData()
            .then((data) => {
                setTickets(data.tickets);
                setErrorRo(data.error_ro ?? "");
                setErrorEn(data.error_en ?? "");
                setErrorEs(data.error_es ?? "");
            })
    });

    if(!currentUser){
        return (
            <div className="relative bg-gray-100 min-h-screen p-5">
                <BackButton onClick={() => navigate('/')}/>
                <h1 className="text-xl font-bold text-center mt-16 mb-4">
                    {t("btn.vipTitle")}
                </h1>
                <h2 className="text-l font-bold text-center my-4">
                    {t("txt.vipLoginError")}
                </h2>
                <div className="flex flex-col items-center justify-center relative">
                    <button
                        onClick={() => navigate('/login')}
                        className="px-4 py-2 bg-[#e74c3c] text-white rounded"
                    >
                        {t("btn.login")}
                    </button>
                </div>
            </div>
        )
    }

    if (!hasVip) {
        return (
            <div className="relative bg-gray-100 min-h-screen p-5">
                <BackButton onClick={() => navigate('/')}/>
                <h1 className="text-xl font-bold text-center mt-16 mb-4">
                    {t("btn.vipTitle")}
                </h1>
                <h2 className="text-l font-bold text-center my-4">
                    {t("txt.vipNoVipSub")}
                </h2>
                <div className="flex flex-col items-center justify-center relative">
                    <button
                        onClick={() => navigate('/subscriptions')}
                        className="px-4 py-2 bg-[#e74c3c] text-white rounded"
                    >
                        {t('btn.subs')}
                    </button>
                </div>
            </div>
        )
    }

    if(tickets.length === 0){
        let errorMessage = t("txt.vipNoTickets");
        if(language === "ro" && errorRo.length > 0){
            errorMessage = errorRo;
        }
        if(language === "en" && errorEn.length > 0){
            errorMessage = errorEn;
        }
        if(language === "es" && errorEs.length > 0){
            errorMessage = errorEs;
        }
        return (
            <div className="relative bg-gray-100 min-h-screen p-5">
                <BackButton onClick={() => navigate('/')}/>
                <h1 className="text-xl font-bold text-center mt-16 mb-4">
                    {t("btn.vipTitle")}
                </h1>
                <h2 className="text-l font-bold text-center my-4">
                    {errorMessage}
                </h2>
                <Footer />
            </div>
        )
    }

    return (
        <div className="relative bg-gray-100 min-h-screen p-5">
            <BackButton onClick={() => navigate('/')}/>
            <h1 className="text-xl font-bold text-center mt-16 mb-4">
                {t("btn.vipTitle")}
            </h1>
            <div className="space-y-4">
                {tickets.map(item => {
                    return (
                        <img src={item} alt={t('btn.vipTitle')}/>
                    )
                })}
            </div>
            <Footer />
        </div>
    );
};

export default VipPage;
